import React, { useEffect, useMemo, useState } from 'react';
import kixieLogo from '../../../images/Kixie-Logo-Full-Red-Cropped-Animated.svg';
import { Button, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useSnackbarWithStyles } from '../../components/notifications/SnackbarProviderWithStyles';
import cookie from 'react-cookies';

const useStyles = makeStyles((_theme) => ({
  root: {
    padding: 8,
  },
  container: {
    flexFlow: 'wrap',
    justifyContent: 'center',
  },
  title: {
    fontSize: '1.1rem',
  },
  titleSpace: {
    marginBottom: '1rem',
  },
}));

export const VerifyEmail = () => {
  const classes = useStyles();
  const { search } = useLocation();
  // const queryParams = useMemo(() => new URLSearchParams(search), [search]);
  const [emailValid, setEmailValid] = useState<boolean>();
  const [businessId, setBusinessId] = useState<number>();
  const { enqueueSnackbarWithStyles } = useSnackbarWithStyles();
  const searchParams = useMemo(() => {
    const queryParams = new URLSearchParams(search);
    return {
      email: queryParams.get('email'),
      code: queryParams.get('code'),
    };
  }, [search]);

  const resendEmail = async () => {
    try {
      const accessToken = cookie.load('accessToken');
      const formData = new FormData();
      formData.append('call', 'getBusinessEmailHash');
      formData.append('businessid', String(businessId));
      const response = await axios.post(
        `${process.env.VITE_APP_PHP_DOMAIN}/rest/functions.php`,
        formData,
        {
          withCredentials: true,
          headers: {
            authorization: accessToken,
          },
        }
      );

      if (response.status === 200) {
        enqueueSnackbarWithStyles({
          message: 'New email sent',
          alertProps: {
            severity: 'success',
          },
        });
      } else {
        throw new Error(
          'getBusinessEmailHash error with with status' + response.status
        );
      }
    } catch (exception) {
      // eslint-disable-next-line no-console
      console.error(exception);

      enqueueSnackbarWithStyles({
        message: 'Unable to send please try again',
        alertProps: {
          severity: 'error',
        },
      });
    }
  };

  useEffect(() => {
    axios
      .post(
        `${process.env.VITE_APP_API_DOMAIN}/${process.env.VITE_APP_API_STAGE}/legacy/verifyEmail`,
        {
          email: searchParams.email,
          code: searchParams.code,
          call: 'verifyEmail',
          apikey: false,
        }
      )
      .then((payload) => {
        setEmailValid(!!payload?.data?.result?.[0]?.verified);
        setBusinessId(payload?.data?.result?.[0]?.businessid);
      })
      .catch((exception) => {
        // eslint-disable-next-line no-console
        console.error(exception);
        setEmailValid(false);
      });
  }, [search]);

  return (
    <div
      className="login login-4 login-signin-on d-flex flex-row-fluid"
      id="kt_login_signin_form"
    >
      <div
        style={{
          // remove all inline styles, replace with makeStyles
          position: 'absolute',
          left: '25px',
          top: '10px',
        }}
      >
        <img
          style={{
            height: '74px',
            width: '182px',
          }}
          src={kixieLogo}
        />
      </div>
      <div
        className="d-flex flex-center flex-row-fluid bgi-size-cover bgi-position-top bgi-no-repeat"
        style={{ backgroundImage: 'url(/media/bg/bg-3.jpg)' }}
      >
        <div className="login-form p-7 position-relative overflow-hidden">
          {/* begin::Head */}
          <div className="d-flex flex-column flex-center mb-15">
            <h3 className="font-size-h1">Verify Email</h3>
          </div>
          {/* end::Head */}

          {/* begin::Form */}
          <div className="login-signin">
            {emailValid === undefined && (
              <div
                className={clsx(
                  'mb-10 alert alert-custom alert-light-info alert-dismissible',
                  classes.container
                )}
              >
                <Typography className={classes.title}>
                  Awaiting verification...
                </Typography>
              </div>
            )}

            {emailValid === true && (
              <div
                className={clsx(
                  'mb-10 alert alert-custom alert-light-success alert-dismissible',
                  classes.container
                )}
              >
                <Typography className={clsx(classes.title, classes.titleSpace)}>
                  Success! Your account is verified.
                </Typography>
                <Typography>
                  If you have not installed the chrome extension, please install
                  extension.
                </Typography>
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                  href="https://chrome.google.com/webstore/detail/kixie-powercall-dialer/bmdpeakaalmaaflnkckhjcojpemlkjig"
                >
                  Install Extension
                </Button>
              </div>
            )}

            {emailValid === false && (
              <div
                className={clsx(
                  'mb-10 alert alert-custom alert-light-danger alert-dismissible',
                  classes.container
                )}
              >
                <Typography className={clsx(classes.title, classes.titleSpace)}>
                  Error! Please request a new email for verification.
                </Typography>
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                  onClick={resendEmail}
                >
                  Request New Email
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
